import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'

import ExternalResponse from '@/components/ExternalResponse'

import Users from '@/components/Users/Users'

import Settings from '@/components/Settings/Settings'

import About from '@/components/About/About'

import Dashboard from '@/components/Dashboard/Dashboard'

import PartManager from '@/components/PartManager/PartManager'

import LibraryManager from '@/components/LibraryManager/LibraryManager'

import ProjectManager from '@/components/ProjectManager/ProjectManager'

import RequestManager from '@/components/RequestManager/RequestManager'






Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/ExternalResponse',
      name: 'ExternalResponse',
      component: ExternalResponse
    },
    {
      path: '/Users/:view',
      name: './Users',
      component: Users,
      children: [
        {
          path: 'Main',

        },

      ]
    },
    {
      path: '/Settings/:view',
      name: './Settings',
      component: Settings,
      children: [
        {
          path: 'Main',

        },

      ]
    },
    {
      path: '/About/:view',
      name: './About',
      component: About,
      children: [
        {
          path: 'Main',

        },

      ]
    },
    {
      path: '/Dashboard/:view',
      name: './Dashboard/Dashboard',
      component: Dashboard,
      children: [
        {
          path: 'Dashboard/DashboardWidgets',

        },
        {
          path: 'Dashboard/DashboardTable',

        }
      ]
    },
    {
      path: '/PartManager/:view',
      name: './PartManager',
      component: PartManager,
      children: [
        {
          path: 'PartTable',

        },
        {
          path: 'PartNew',

        },
        {
          path: 'PartDetails',

        },
        {
          path: 'PartDerive',

        },
        {
          path: 'PartSearch',

        },
        {
          path: 'PartAssembly'
        },
        {
          path: 'PartPhysicals'
        }
      ]
    },
    {
      path: '/LibraryManager/:view',
      name: './LibraryManager',
      component: LibraryManager,
      children: [
        {
          path: 'LibraryTable',

        },
        {
          path: 'LibraryNew',

        },
        {
          path: 'LibraryDetails',

        },
        {
          path: 'LibraryDerive',

        },
        {
          path: 'LibraryImport',

        },

      ]
    },

    {
      path: '/ProjectManager/:view',
      name: './ProjectManager',
      component: ProjectManager,
      children: [
        {
          path: 'ProjectTable',

        },
        {
          path: 'ProjectNew',

        },
        {
          path: 'ProjectDetails',

        },
        {
          path: 'ProjectDerive',

        },
        {
          path: 'ProjectImportIPC',

        },
      ]
    },
    {
      path: '/RequestManager/:view',
      name: './RequestManager',
      component: RequestManager,
      children: [
        {
          path: 'RequestTable',

        },
        {
          path: 'RequestNew',

        },
        {
          path: 'RequestDetails',

        },


      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js